import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.4848 0) scale(0.9697)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M28 27L22.2 21.2M14.6667 7C18.3486 7 21.3333 9.98477 21.3333 13.6667M25.3333 13.6667C25.3333 19.5577 20.5577 24.3333 14.6667 24.3333C8.77563 24.3333 4 19.5577 4 13.6667C4 7.77563 8.77563 3 14.6667 3C20.5577 3 25.3333 7.77563 25.3333 13.6667Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.6667 24.3333C20.5577 24.3333 25.3333 19.5577 25.3333 13.6667C25.3333 7.77563 20.5577 3 14.6667 3C8.77563 3 4 7.77563 4 13.6667C4 19.5577 8.77563 24.3333 14.6667 24.3333Z",
					style: { fill: "var(--sticker-pastel,#D0DBFF)" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 27L22.2 21.2M14.6667 7C18.3486 7 21.3333 9.98477 21.3333 13.6667M25.3333 13.6667C25.3333 19.5577 20.5577 24.3333 14.6667 24.3333C8.77563 24.3333 4 19.5577 4 13.6667C4 7.77563 8.77563 3 14.6667 3C20.5577 3 25.3333 7.77563 25.3333 13.6667Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#505772)" }
				})
			]
		})
	});
};
export default SvgSearch;
